import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconDesk = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconDesk.dimensions.width} ${IconDesk.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        d="M1.043 7.84c.352-.019.705 0 1.095 0v9.154h.647V7.865h1.816c.085.338.19.658.243.99.1.626.368.896.931.84.606-.057 1.216-.013 1.843-.013v1.178h-.606c-.72 0-1.442-.013-2.163 0-.769.019-1.3.595-1.29 1.378.01.765.532 1.335 1.263 1.354.485.012.974 0 1.459 0h1.316v2.13c-.721 0-1.406-.025-2.085.019-.184.012-.479.2-.516.37a3.191 3.191 0 0 0-.042.87h.684c.006-.138 0-.282.011-.426h4.675c0 .157-.016.295-.016.426h.68c0-.175-.022-.363-.006-.539.037-.52-.148-.745-.595-.726-.68.025-1.358.006-2.053.006v-2.1c.2-.012.379-.03.553-.03.72 0 1.442.012 2.163 0 .742-.02 1.248-.577 1.258-1.354.011-.795-.473-1.347-1.22-1.378-.254-.013-.506 0-.759 0H8.334V9.682c.653 0 1.28-.031 1.905.012.453.032.659-.188.753-.683.074-.388.19-.764.28-1.121h7.964V17h.648V7.934l1.616-.232V4.864c-.416-.057-.837-.107-1.269-.163h-8.37c0-.677.016-1.316 0-1.955-.032-1.072-.442-1.836-1.316-2.2C8.78-.18 7.012-.185 5.249.554c-.842.35-1.274 1.084-1.29 2.143-.01.658 0 1.316 0 2.036-.995 0-1.963.013-2.937 0-.364 0-.532.144-.522.595.016.646.016 1.291 0 1.93-.01.457.164.608.527.589l.016-.006Zm10.681-2.312h9.113v1.491h-9.37l.252-1.491h.005Zm-.758 6.052c.369 0 .68.12.669.62-.01.464-.322.558-.664.558-1.01-.006-2.016 0-3.027 0H4.917c-.337 0-.653-.081-.668-.545-.016-.495.294-.633.663-.633h6.054ZM5.633 1.167c1.522-.583 3.048-.583 4.57 0 .7.27 1.037.846 1.047 1.736.027 2.048-.447 3.978-.9 5.94H8.308c0-.458.036-.903-.016-1.335-.027-.207-.227-.389-.348-.577-.094.194-.252.382-.273.59-.043.419-.011.845-.011 1.302H5.538c-.479-1.948-.937-3.903-.916-5.97.011-.872.343-1.43 1.022-1.686h-.01ZM1.211 5.54h2.932c.085.464.169.934.269 1.492h-3.2V5.54Z"
      />
    </Svg>
  )
}

IconDesk.dimensions = {
  width: 22,
  height: 15,
}

export default IconDesk
